// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"8L5U8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function toPercent(num) {
    if (num <= 0) return '100%';
    if (num < 1) return `${num * 100}%`;
    return `${num}%`;
}
const Ratio = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, children, aspectRatio = '1x1', style, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'ratio');
    const isCustomRatio = typeof aspectRatio === 'number';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: ref,
        ...props,
        style: {
            ...style,
            ...isCustomRatio && {
                '--bs-aspect-ratio': toPercent(aspectRatio)
            }
        },
        className: (0, _classnamesDefault.default)(bsPrefix, className, !isCustomRatio && `${bsPrefix}-${aspectRatio}`),
        children: _react.Children.only(children)
    });
});
exports.default = Ratio;

},{"classnames":"7jDU8","react":"4i8qR","./ThemeProvider":"5hdxY","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"kS789":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTypeAnimation = require("react-type-animation");
"use client";
const typeAnimationSequence = [
    "Architects",
    1000,
    "",
    200,
    "Designers",
    1000,
    "",
    200,
    "Developers",
    1000,
    "",
    200,
    "Mathematicians",
    1000,
    "",
    200,
    "Everyone!",
    1000,
    "",
    200
];
const InnovativeText = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "innovative-text",
        children: [
            "An Innovative Tool for ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTypeAnimation.TypeAnimation), {
                sequence: typeAnimationSequence,
                repeat: Infinity,
                className: "intended-for-text"
            })
        ]
    });
};
exports.default = InnovativeText;

},{"react/jsx-runtime":"fjRB4","react":"4i8qR","react-type-animation":"5ZWR5","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"5ZWR5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypeAnimation", ()=>m);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function i(e, t, r, n) {
    return new (r || (r = Promise))(function(o, a) {
        function i(e) {
            try {
                c(n.next(e));
            } catch (e) {
                a(e);
            }
        }
        function u(e) {
            try {
                c(n.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function c(e) {
            var t;
            e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(i, u);
        }
        c((n = n.apply(e, t || [])).next());
    });
}
function u(e, t) {
    var r, n, o, a, i = {
        label: 0,
        sent: function() {
            if (1 & o[0]) throw o[1];
            return o[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: u(0),
        throw: u(1),
        return: u(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function u(a) {
        return function(u) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; i;)try {
                    if (r = 1, n && (o = 2 & a[0] ? n.return : a[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, a[1])).done) return o;
                    switch(n = 0, o && (a = [
                        2 & a[0],
                        o.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            o = a;
                            break;
                        case 4:
                            return i.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            i.label++, n = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(o = i.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === a[0] && (!o || a[1] > o[0] && a[1] < o[3])) {
                                i.label = a[1];
                                break;
                            }
                            if (6 === a[0] && i.label < o[1]) {
                                i.label = o[1], o = a;
                                break;
                            }
                            if (o && i.label < o[2]) {
                                i.label = o[2], i.ops.push(a);
                                break;
                            }
                            o[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    a = t.call(e, i);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], n = 0;
                } finally{
                    r = o = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                u
            ]);
        };
    }
}
function c(e) {
    var t = "function" == typeof Symbol && Symbol.iterator, r = t && e[t], n = 0;
    if (r) return r.call(e);
    if (e && "number" == typeof e.length) return {
        next: function() {
            return e && n >= e.length && (e = void 0), {
                value: e && e[n++],
                done: !e
            };
        }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function l(e, t) {
    var r = "function" == typeof Symbol && e[Symbol.iterator];
    if (!r) return e;
    var n, o, a = r.call(e), i = [];
    try {
        for(; (void 0 === t || t-- > 0) && !(n = a.next()).done;)i.push(n.value);
    } catch (e) {
        o = {
            error: e
        };
    } finally{
        try {
            n && !n.done && (r = a.return) && r.call(a);
        } finally{
            if (o) throw o.error;
        }
    }
    return i;
}
function s(e, t, r) {
    if (r || 2 === arguments.length) for(var n, o = 0, a = t.length; o < a; o++)!n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
    return e.concat(n || Array.prototype.slice.call(t));
}
function f(e, t, r, n, o) {
    for(var a = [], f = 5; f < arguments.length; f++)a[f - 5] = arguments[f];
    return i(this, void 0, void 0, function() {
        var i, f, h, y, v, b;
        return u(this, function(u) {
            switch(u.label){
                case 0:
                    u.trys.push([
                        0,
                        12,
                        13,
                        14
                    ]), i = c(a), f = i.next(), u.label = 1;
                case 1:
                    if (f.done) return [
                        3,
                        11
                    ];
                    switch(h = f.value, typeof h){
                        case "string":
                            return [
                                3,
                                2
                            ];
                        case "number":
                            return [
                                3,
                                4
                            ];
                        case "function":
                            return [
                                3,
                                6
                            ];
                    }
                    return [
                        3,
                        8
                    ];
                case 2:
                    return [
                        4,
                        d(e, t, h, r, n, o)
                    ];
                case 3:
                    return u.sent(), [
                        3,
                        10
                    ];
                case 4:
                    return [
                        4,
                        p(h)
                    ];
                case 5:
                    return u.sent(), [
                        3,
                        10
                    ];
                case 6:
                    return [
                        4,
                        h.apply(void 0, s([
                            e,
                            t,
                            r,
                            n,
                            o
                        ], l(a), !1))
                    ];
                case 7:
                    return u.sent(), [
                        3,
                        10
                    ];
                case 8:
                    return [
                        4,
                        h
                    ];
                case 9:
                    u.sent(), u.label = 10;
                case 10:
                    return f = i.next(), [
                        3,
                        1
                    ];
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    return y = u.sent(), v = {
                        error: y
                    }, [
                        3,
                        14
                    ];
                case 13:
                    try {
                        f && !f.done && (b = i.return) && b.call(i);
                    } finally{
                        if (v) throw v.error;
                    }
                    return [
                        7
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    });
}
function d(e, t, r, n, o, a) {
    return i(this, void 0, void 0, function() {
        var i, c;
        return u(this, function(u) {
            switch(u.label){
                case 0:
                    return i = e.textContent || "", c = function(e, t) {
                        var r = l(t).slice(0);
                        return s(s([], l(e), !1), [
                            NaN
                        ], !1).findIndex(function(e, t) {
                            return r[t] !== e;
                        });
                    }(i, r), [
                        4,
                        h(e, s(s([], l(v(i, t, c)), !1), l(y(r, t, c)), !1), n, o, a)
                    ];
                case 1:
                    return u.sent(), [
                        2
                    ];
            }
        });
    });
}
function p(e) {
    return i(this, void 0, void 0, function() {
        return u(this, function(t) {
            switch(t.label){
                case 0:
                    return [
                        4,
                        new Promise(function(t) {
                            return setTimeout(t, e);
                        })
                    ];
                case 1:
                    return t.sent(), [
                        2
                    ];
            }
        });
    });
}
function h(e, t, r, n, o) {
    return i(this, void 0, void 0, function() {
        var a, i, s, f, d, h, y, v, b, m, w, g, x;
        return u(this, function(S) {
            switch(S.label){
                case 0:
                    if (a = t, o) {
                        for(i = 0, s = 1; s < t.length; s++)if (f = l([
                            t[s - 1],
                            t[s]
                        ], 2), d = f[0], (h = f[1]).length > d.length || "" === h) {
                            i = s;
                            break;
                        }
                        a = t.slice(i, t.length);
                    }
                    S.label = 1;
                case 1:
                    S.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]), y = c(function(e) {
                        var t, r, n, o, a, i, l;
                        return u(this, function(s) {
                            switch(s.label){
                                case 0:
                                    t = function(e) {
                                        return u(this, function(t) {
                                            switch(t.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        {
                                                            op: function(t) {
                                                                return requestAnimationFrame(function() {
                                                                    return t.textContent = e;
                                                                });
                                                            },
                                                            opCode: function(t) {
                                                                var r = t.textContent || "";
                                                                return "" === e || r.length > e.length ? "DELETE" : "WRITING";
                                                            }
                                                        }
                                                    ];
                                                case 1:
                                                    return t.sent(), [
                                                        2
                                                    ];
                                            }
                                        });
                                    }, s.label = 1;
                                case 1:
                                    s.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]), r = c(e), n = r.next(), s.label = 2;
                                case 2:
                                    return n.done ? [
                                        3,
                                        5
                                    ] : (o = n.value, [
                                        5,
                                        t(o)
                                    ]);
                                case 3:
                                    s.sent(), s.label = 4;
                                case 4:
                                    return n = r.next(), [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    return a = s.sent(), i = {
                                        error: a
                                    }, [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        n && !n.done && (l = r.return) && l.call(r);
                                    } finally{
                                        if (i) throw i.error;
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }(a)), v = y.next(), S.label = 2;
                case 2:
                    return v.done ? [
                        3,
                        5
                    ] : (b = v.value, m = "WRITING" === b.opCode(e) ? r + r * (Math.random() - .5) : n + n * (Math.random() - .5), b.op(e), [
                        4,
                        p(m)
                    ]);
                case 3:
                    S.sent(), S.label = 4;
                case 4:
                    return v = y.next(), [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    return w = S.sent(), g = {
                        error: w
                    }, [
                        3,
                        8
                    ];
                case 7:
                    try {
                        v && !v.done && (x = y.return) && x.call(y);
                    } finally{
                        if (g) throw g.error;
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
}
function y(e, t, r) {
    var n, o;
    return void 0 === r && (r = 0), u(this, function(a) {
        switch(a.label){
            case 0:
                n = t(e), o = n.length, a.label = 1;
            case 1:
                return r < o ? [
                    4,
                    n.slice(0, ++r).join("")
                ] : [
                    3,
                    3
                ];
            case 2:
                return a.sent(), [
                    3,
                    1
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
function v(e, t, r) {
    var n, o;
    return void 0 === r && (r = 0), u(this, function(a) {
        switch(a.label){
            case 0:
                n = t(e), o = n.length, a.label = 1;
            case 1:
                return o > r ? [
                    4,
                    n.slice(0, --o).join("")
                ] : [
                    3,
                    3
                ];
            case 2:
                return a.sent(), [
                    3,
                    1
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
var b = "index-module_type__E-SaG";
!function(e, t) {
    void 0 === t && (t = {});
    var r = t.insertAt;
    if (e && "undefined" != typeof document) {
        var n = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
        o.type = "text/css", "top" === r && n.firstChild ? n.insertBefore(o, n.firstChild) : n.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
    }
}(".index-module_type__E-SaG::after {\n  content: '|';\n  animation: index-module_cursor__PQg0P 1.1s infinite step-start;\n}\n\n@keyframes index-module_cursor__PQg0P {\n  50% {\n    opacity: 0;\n  }\n}\n");
var m = (0, _react.memo)((0, _react.forwardRef)(function(o, a) {
    var i = o.sequence, u = o.repeat, c = o.className, d = o.speed, p = void 0 === d ? 40 : d, h = o.deletionSpeed, y = o.omitDeletionAnimation, v = void 0 !== y && y, m = o.preRenderFirstString, w = void 0 !== m && m, g = o.wrapper, x = void 0 === g ? "span" : g, S = o.splitter, E = void 0 === S ? function(e) {
        return s([], l(e), !1);
    } : S, _ = o.cursor, k = void 0 === _ || _, O = o.style, T = function(e, t) {
        var r = {};
        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for(n = Object.getOwnPropertySymbols(e); o < n.length; o++)t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
        }
        return r;
    }(o, [
        "sequence",
        "repeat",
        "className",
        "speed",
        "deletionSpeed",
        "omitDeletionAnimation",
        "preRenderFirstString",
        "wrapper",
        "splitter",
        "cursor",
        "style"
    ]), A = T["aria-label"], C = T["aria-hidden"], N = T.role;
    h || (h = p);
    var P = new Array(2).fill(40);
    [
        p,
        h
    ].forEach(function(e, t) {
        switch(typeof e){
            case "number":
                P[t] = Math.abs(e - 100);
                break;
            case "object":
                var r = e.type, n = e.value;
                if ("number" != typeof n) break;
                if ("keyStrokeDelayInMs" === r) P[t] = n;
        }
    });
    var j, I, G, D, M, R, q = P[0], F = P[1], B = function(e, r) {
        void 0 === r && (r = null);
        var o = (0, _react.useRef)(r);
        return (0, _react.useEffect)(function() {
            e && ("function" == typeof e ? e(o.current) : e.current = o.current);
        }, [
            e
        ]), o;
    }(a), Q = b;
    j = c ? "".concat(k ? Q + " " : "").concat(c) : k ? Q : "", I = (0, _react.useRef)(function() {
        var e, t = i;
        u === 1 / 0 ? e = f : "number" == typeof u && (t = Array(1 + u).fill(i).flat());
        var r = e ? s(s([], l(t), !1), [
            e
        ], !1) : s([], l(t), !1);
        return f.apply(void 0, s([
            B.current,
            E,
            q,
            F,
            v
        ], l(r), !1)), function() {
            B.current;
        };
    }), G = (0, _react.useRef)(), D = (0, _react.useRef)(!1), M = (0, _react.useRef)(!1), R = l((0, _react.useState)(0), 2)[1], D.current && (M.current = !0), (0, _react.useEffect)(function() {
        return D.current || (G.current = I.current(), D.current = !0), R(function(e) {
            return e + 1;
        }), function() {
            M.current && G.current && G.current();
        };
    }, []);
    var W = x, L = w ? i.find(function(e) {
        return "string" == typeof e;
    }) || "" : null;
    return (0, _reactDefault.default).createElement(W, {
        "aria-hidden": C,
        "aria-label": A,
        role: N,
        style: O,
        className: j,
        children: A ? (0, _reactDefault.default).createElement("span", {
            "aria-hidden": "true",
            ref: B,
            children: L
        }) : L,
        ref: A ? void 0 : B
    });
}), function(e, t) {
    return !0;
});

},{"react":"4i8qR","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}],"1P3xF":[function(require,module,exports,__globalThis) {
var _client = require("@parcel/rsc/client");
"use client-entry";
// Google Analytics
const gtagScript = document.createElement('script');
gtagScript.async = true;
gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-W8PJRWMR5Q';
document.head.appendChild(gtagScript);
const gtagConfig = document.createElement('script');
gtagConfig.innerHTML = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-W8PJRWMR5Q');
`;
document.head.appendChild(gtagConfig);
(0, _client.hydrate)();

},{"@parcel/rsc/client":"4IgxY"}],"Eomfz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propTypes", ()=>propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _themeProvider = require("./ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
const propTypes = {
    /**
   * @default 'img'
   */ bsPrefix: (0, _propTypesDefault.default).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, _propTypesDefault.default).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, _propTypesDefault.default).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, _propTypesDefault.default).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, _propTypesDefault.default).bool
};
const Image = /*#__PURE__*/ _react.forwardRef(({ bsPrefix, className, fluid = false, rounded = false, roundedCircle = false, thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, _themeProvider.useBootstrapPrefix)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        // eslint-disable-line jsx-a11y/alt-text
        ref: ref,
        ...props,
        className: (0, _classnamesDefault.default)(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
Image.displayName = 'Image';
exports.default = Image;

},{"classnames":"7jDU8","react":"4i8qR","prop-types":"bW7sO","./ThemeProvider":"5hdxY","react/jsx-runtime":"fjRB4","@parcel/transformer-js/src/esmodule-helpers.js":"bPrDz"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Landing.58a45446.js.map
